import { CheckoutAbTestMetricToOptimize } from "@redotech/redo-model/checkouts/checkout-ab-test-builder";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const possiblyDeletedCheckoutExperienceSchema = z.union([
  z.object({ _id: zExt.objectId(), name: z.string() }),
  z.object({ _id: zExt.objectId(), deleted: z.literal(true) }),
]);
export type PossiblyDeletedCheckoutExperience = z.infer<
  typeof possiblyDeletedCheckoutExperienceSchema
>;

const baseSplitInfoSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  active: z.boolean(),
  createdAt: z.date(),
  controlCheckoutExperiences: z.array(possiblyDeletedCheckoutExperienceSchema),
  experimentCheckoutExperiences: z.array(
    possiblyDeletedCheckoutExperienceSchema,
  ),
  metricToOptimize: createEnum(CheckoutAbTestMetricToOptimize),
  testDurationDays: z.number().optional(),
  visits: z.number().optional(),
  revenueImpact: z.string().optional(),
  conversionRateOfWinningTreatment: z.string().optional(),
  aovOfWinningTreatment: z.string().optional(),
  rootSplitId: zExt.objectId().optional(),
  parentSplitId: zExt.objectId().optional(),
  generation: z.number().optional(),
});

const concludedSplitInfoSchema = baseSplitInfoSchema.extend({
  active: z.literal(false),
  concludedAt: z.date().optional(),
});
export type ConcludedSplitInfo = z.infer<typeof concludedSplitInfoSchema>;

const activeSplitInfoSchema = baseSplitInfoSchema.extend({
  active: z.literal(true),
});
export type ActiveSplitInfo = z.infer<typeof activeSplitInfoSchema>;

export const getConcludedAndActiveCheckoutSplits = {
  name: "getConcludedAndActiveCheckoutSplits" as const,
  input: z.null(),
  output: z.object({
    concludedSplits: z.array(concludedSplitInfoSchema),
    activeSplits: z.array(activeSplitInfoSchema),
  }),
};
export type GetConcludedAndActiveCheckoutSplitsOutput = z.infer<
  typeof getConcludedAndActiveCheckoutSplits.output
>;
